import about from "./about.json";
import diagSecu from "./diagSecu.json";
import admin from "./admin.json";
import client from "./client.json";
import common from "./common.json";
import compInfos from "./compInfos.json";
import contact from "./contact.json";
import date from "./date.json";
import index from "./default.json";
import form from "./form.json";
import login from "./login.json";
import machine from "./machine.json";
import menu from "./menu.json";
import piece from "./piece.json";
import planification from "./planification.json";
import prospect from "./prospect.json";
import quotation from "./quotation.json";
import resetPassword from "./resetPassword.json";
import settings from "./settings.json";
import stats from "./stats.json";
import technician from "./technician.json";
import time from "./time.json";
import user from "./user.json";
import workorder from "./workorder.json";
import error from "./error.json";
import replenishment from "./replenishment.json";

const lang = {
  default: index,
  menu,
  settings,
  form,
  planification,
  prospect,
  workorder,
  common,
  date,
  quotation,
  technician,
  contact,
  client,
  resetPassword,
  user,
  stats,
  time,
  piece,
  machine,
  compInfos,
  login,
  about,
  admin,
  error,
  replenishment,
  diagSecu
};

export default lang;

